<template>
  <component 
		:is="component" 
		:class="rootClassName">
    <slot />
  </component>
</template>

<script>

export default {
  name: 'ListItemText',

  props: {
    component: {
      type: [ Object, String ],
      default: 'span'
    }
  },

  computed: {
    rootClassName () {
      return [ this.$style.root ]
    }
  }
}

</script>

<style module> 

.root {
	@apply 
		pr-4
}

</style>
